"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _htmlEntities = require("html-entities");

var stripHTML = function stripHTML(html) {
  var regex = /<[^>]*>/gm;
  var stripedHtml = html.replace(regex, '');
  return (0, _htmlEntities.decode)(stripedHtml);
};

var _default = stripHTML;
exports["default"] = _default;
//# sourceMappingURL=stripHTML.js.map